<app-icon-button-dialog
  icon="pi pi-chart-bar"
  header="provider.tenders.phases.providerResponse"
  [colorClass]="colorClass()"
  [disabled]="!hasProviderResponse()"
  (opened)="dialogOpened.set(true)"
>
  @if (tenderDetailsResource.isLoading()) {
    <app-loading />
  } @else {
    @if (tenderDetailsResource.value(); as tenderDetails) {
      <p-card class="w-full text-left">
        @if (
          phaseStatusInfo().phase === TenderPhaseType.RFI ||
          phaseStatusInfo().phase === TenderPhaseType.RFP
        ) {
          <app-generic-questionnaire
            [readonly]="true"
            [tenderId]="tenderId()"
            [phaseType]="phaseStatusInfo().phase"
            [tenderDetails]="tenderDetails"
          />
        } @else if (phaseStatusInfo().phase === TenderPhaseType.RFD) {
          <app-tender-demonstration-agenda [tenderId]="tenderId()" />
        } @else if (phaseStatusInfo().phase === TenderPhaseType.RFQ) {
          <app-tender-project-response-rfq [tenderId]="tenderId()" />
        } @else if (phaseStatusInfo().phase === TenderPhaseType.RFC) {
          <app-tender-project-rfc-project-conclusion
            [hasActivities]="false"
            [tenderDetails]="tenderDetails"
          ></app-tender-project-rfc-project-conclusion>
        }
      </p-card>
    }
  }
</app-icon-button-dialog>
